"use client";
import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import { Button } from "@dxp-feed/ui/Button";
import Link from "@/components/Link";
import { useAppSelector, useRef } from "@/utils/hooks/reactUseCustomHooks";
import { RecipeImage } from "@/utils/constant";
import ImageWrapper from "@/components/ImageWrapper";
import useRecipes from "@/templates/recipes/common/commonRecipeFunctions/getRecipes";
import ToastMessage from "@/templates/common/ToastMessage";
import RecipeCard from "@/templates/recipes/UI/Cards/RecipeCarouselCard";
interface Recipe {
  homepageBanner: any;
  homePageRecipeData: any;
}

export default function Recipe({ homepageBanner, homePageRecipeData }: Recipe) {
  const hasAddToFavRun = useRef(false);
  const { favourite } = useAppSelector((state) => state.RecipeToList);
  useRecipes();

  return (
    <>
      <ToastMessage />
      {homepageBanner?.banner && (
        <Box as="div" className="bg-brandWhite">
          <Box as="div">
            <Box
              as="div"
              className="grid xl:grid-cols-2 md:gap-[16px] lg:gap-[24px] gap-[24px] recipeSecton"
            >
              <Box
                as="div"
                className="flex flex-col items-start rounded-xl pr-[24px] 2md:pr-[48px] lg:pr-0 h-full"
              >
                <Box as="div" className="w-full bg-grey300 rounded-t-xl h-full">
                  {homepageBanner?.banner?.image && (
                    <ImageWrapper
                      src={`${RecipeImage + homepageBanner?.banner?.image || homepageBanner?.banner?.image}`}
                      width={708}
                      height={464}
                      className="w-full h-full rounded-t-xl object-cover"
                      alt="Fathers day"
                    />
                  )}
                </Box>
                <Box
                  as="div"
                  className="p-4 md:p-8 bg-brandSecondary w-full rounded-b-xl"
                >
                  <Text
                    as="h4"
                    className="text-brandWhite title-tertiary mb-1 md:mb-2 font-sans"
                  >
                    {homepageBanner?.banner?.heading}
                  </Text>
                  <Text
                    as="p"
                    className="text-brandWhite text-base font-normal mb-[16px] md:mb-[24px]"
                  >
                    {homepageBanner?.banner?.description
                      ? new DOMParser().parseFromString(
                          homepageBanner?.banner?.description,
                          "text/html"
                        )?.body?.textContent
                      : ""}
                  </Text>
                  <Button variant="outlineWhite" asChild>
                    {homepageBanner?.banner?.ctaList[0]?.link && (
                      <Link
                        className="font-normal bg-brandWhite border-[1px] text-brandBlack before:bg-brandSecondary border-brandWhite !text-body focus:text-brandWhite hover:text-brandWhite  px-[24px]"
                        href={homepageBanner?.banner?.ctaList[0]?.link}
                        target={homepageBanner?.banner?.ctaList[0]?.target}
                        aria-label={
                          homepageBanner?.banner?.ctaList[0]?.ariaLabel
                        }
                      >
                        {homepageBanner?.banner?.ctaList[0]?.linkTitle}
                      </Link>
                    )}
                  </Button>
                </Box>
              </Box>

              <Box
                as="div"
                className="p-[1px] flex flex-row gap-2 md:gap-6 items-stretch h-full overflow-x-auto lg:overflow-visible lg:grid lg:grid-cols-2 2lg:grid-cols-4 xl:grid-cols-2 scrollbar-hide whitespace-nowrap pr-6 lg:pr-0"
              >
                {homePageRecipeData?.map((item: any, _index: number) => {
                  return (
                    <RecipeCard
                      key={item.id}
                      item={item}
                      favouritesRecipes={favourite?.recipes}
                      hasAddToFavRun={hasAddToFavRun}
                      list_name={
                        homepageBanner?.recipeheading?.heading ||
                        "Recipes For You"
                      }
                      index={_index}
                    />
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
